// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Teim","bigColWidth":"Table_bigColWidth__1E3sy","biggerColWidth":"Table_biggerColWidth__HJ4vV","row":"Table_row__LtCaX","col":"Table_col__1nHes"};